"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeasureAngleMode = void 0;

var _bearing = _interopRequireDefault(require("@turf/bearing"));

var _center = _interopRequireDefault(require("@turf/center"));

var _memoize = _interopRequireDefault(require("../memoize"));

var _geojsonEditMode = require("./geojson-edit-mode");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT_TOOLTIPS = [];

var MeasureAngleMode = /*#__PURE__*/function (_GeoJsonEditMode) {
  _inherits(MeasureAngleMode, _GeoJsonEditMode);

  var _super = _createSuper(MeasureAngleMode);

  function MeasureAngleMode() {
    var _this;

    _classCallCheck(this, MeasureAngleMode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_getTooltips", (0, _memoize["default"])(function (_ref) {
      var modeConfig = _ref.modeConfig,
          vertex = _ref.vertex,
          point1 = _ref.point1,
          point2 = _ref.point2;
      var tooltips = DEFAULT_TOOLTIPS;

      if (vertex && point1 && point2) {
        var _ref2 = modeConfig || {},
            formatTooltip = _ref2.formatTooltip,
            measurementCallback = _ref2.measurementCallback;

        var units = 'deg';
        var angle1 = (0, _bearing["default"])(vertex, point1);
        var angle2 = (0, _bearing["default"])(vertex, point2);
        var angle = Math.abs(angle1 - angle2);

        if (angle > 180) {
          angle = 360 - angle;
        }

        var text;

        if (formatTooltip) {
          text = formatTooltip(angle);
        } else {
          // By default, round to 2 decimal places and append units
          // @ts-ignore
          text = "".concat(parseFloat(angle).toFixed(2), " ").concat(units);
        }

        if (measurementCallback) {
          measurementCallback(angle);
        }

        var position = (0, _center["default"])({
          type: 'FeatureCollection',
          features: [point1, point2].map(function (p) {
            return {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: p
              }
            };
          })
        }).geometry.coordinates;
        tooltips = [{
          position: position,
          text: text
        }];
      }

      return tooltips;
    }));

    return _this;
  }

  _createClass(MeasureAngleMode, [{
    key: "handleClick",
    value: function handleClick(event, props) {
      if (this.getClickSequence().length >= 3) {
        this.resetClickSequence();
      }

      this.addClickSequence(event);
    } // Called when the pointer moved, regardless of whether the pointer is down, up, and whether something was picked

  }, {
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      props.onUpdateCursor('cell');
    }
  }, {
    key: "getPoints",
    value: function getPoints(props) {
      var clickSequence = this.getClickSequence();

      var points = _toConsumableArray(clickSequence);

      if (clickSequence.length < 3 && props.lastPointerMoveEvent) {
        points.push(props.lastPointerMoveEvent.mapCoords);
      }

      return points;
    } // Return features that can be used as a guide for editing the data

  }, {
    key: "getGuides",
    value: function getGuides(props) {
      var guides = {
        type: 'FeatureCollection',
        features: []
      };
      var features = guides.features;
      var points = this.getPoints(props);

      if (points.length > 2) {
        features.push({
          type: 'Feature',
          properties: {
            guideType: 'tentative'
          },
          geometry: {
            type: 'LineString',
            coordinates: [points[1], points[0], points[2]]
          }
        });
      } else if (points.length > 1) {
        features.push({
          type: 'Feature',
          properties: {
            guideType: 'tentative'
          },
          geometry: {
            type: 'LineString',
            coordinates: [points[1], points[0]]
          }
        });
      }

      return guides;
    }
  }, {
    key: "getTooltips",
    value: function getTooltips(props) {
      var points = this.getPoints(props);
      return this._getTooltips({
        modeConfig: props.modeConfig,
        vertex: points[0],
        point1: points[1],
        point2: points[2]
      });
    }
  }]);

  return MeasureAngleMode;
}(_geojsonEditMode.GeoJsonEditMode);

exports.MeasureAngleMode = MeasureAngleMode;